import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { TAG_TYPE_LIST } from './tags';

// THE single API instance. Serves REST and GraphQL endpoints — see baseQuery.js.
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: TAG_TYPE_LIST,
  endpoints: () => ({}),
});
